import React from 'react';
import Image from 'next/image';
import styles from './BroadcasterSocialMedia.module.scss';

interface SocialLink {
  name: string;
  url: string;
  logo: string;
}

const BroadcasterSocialMediaComponent: React.FC = () => {
  const socialLinks: SocialLink[] = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/alfaqrawan',
      logo: '/images/social-logos/facebook-logo.svg',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/alfaqrawan',
      logo: '/images/social-logos/instagram-logo.svg',
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@alfaqrawan',
      logo: '/images/social-logos/youtube-logo.svg',
    },
  ];

  return (
    <div className={styles.socialMediaContainer}>
      <h2 className={styles.title}>Follow Us</h2>
      <div className={styles.linksWrapper}>
        {socialLinks.map((link) => (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
            aria-label={`Visit our ${link.name} page`}
          >
            <div className={styles.logoContainer}>
              <Image
                src={link.logo}
                alt={`${link.name} logo`}
                width={48}
                height={48}
                className={styles.logo}
              />
            </div>
            <span className={styles.linkName}>{link.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default BroadcasterSocialMediaComponent;
